/**
 * Created by r4zi4l on 29.01.2021
 */

const InstantWorkerView = cc.Node.extend({
    ctor: function (worker, unitView) {
        this._super();

        this.worker = worker;
        this.unitView = unitView;

        this.restoreState();
    },

    startMagic: function () {
        this.restoreState(true);
    },

    finishMagic: function () {
        this.runAction(new cc.Sequence(
            new cc.DelayTime(cleverapps.styles.InstantWorkerView.jump.duration),
            new cc.CallFunc(() => {
                this.restoreState(true);
            })
        ));
    },

    restoreState: function (animated) {
        if (this.worker.isWorking()) {
            this.unitView.hideSprite();
        } else {
            this.unitView.showSprite();
        }

        if (this.worker.isFresh() || this.worker.isWorking() || InfoView.IsDisplayedFor(this.worker.unit)) {
            this.removeProgress(animated);
        } else {
            this.createProgress(animated);
        }
    },

    createProgress: function (animated) {
        if (this.progress) {
            return;
        }

        const styles = cleverapps.styles.InstantWorkerView.progress;

        const progress = this.progress = new ScaledProgressBar({
            type: styles.type
        });
        progress.setLength(styles.width);
        progress.setAlignment(styles);
        progress.setPercentage(this.worker.getPercentage());
        this.addChild(this.progress);

        progress.baseScale = progress.scale;

        if (animated) {
            progress.runAction(new cc.Sequence(
                new cc.MoveBy(0, 0, -styles.offsetY),
                new cc.ScaleTo(0, this.progress.baseScale / 2),
                new cc.Show(),
                new cc.Spawn(
                    new cc.MoveBy(0.1, 0, styles.offsetY),
                    new cc.ScaleTo(0.1, this.progress.baseScale)
                )
            ));
        }
    },

    removeProgress: function () {
        if (!this.progress) {
            return;
        }

        this.progress.removeFromParent();
        this.progress = undefined;
    }
});

InstantWorkerView.getBuildAnimationTime = function (worker) {
    return UnitView.getUnitImage(worker.unit).getAnimationDuration("building") * 1000;
};

InstantWorkerView.createInstantAnimation = function (unitView, worker, time) {
    if (unitView.aboveInstantAnimation || unitView.belowInstantAnimation) {
        return;
    }

    const aboveAnimation = unitView.aboveInstantAnimation = InstantWorkerView.createAboveAnimation(unitView, worker);

    if (cleverapps.Spine.hasAnimation("building_back", UnitView.UnitIconJson(worker.unit))) {
        const belowAnimation = UnitView.getUnitImage(worker.unit, { defaultAnimation: "building_back" });
        belowAnimation.setAnchorPoint(aboveAnimation.anchorX, aboveAnimation.anchorY);
        belowAnimation.setPosition(aboveAnimation.x, aboveAnimation.y);
        belowAnimation.setLocalZOrder(-1);
        unitView.addChild(belowAnimation);
        unitView.belowInstantAnimation = belowAnimation;
    }

    const flyingDuration = cleverapps.styles.InstantWorkerView.jump.duration * 1000;
    const buildingAnimationTime = InstantWorkerView.getBuildAnimationTime(worker);

    const completedFraction = (Date.now() - worker.startBuildTime) / time;
    const uncompleted = 1 - completedFraction;

    let delta = Math.min(time, worker.limit);
    delta = Math.round(uncompleted * delta);

    const targetTime = Math.max(0, time - worker.limit);
    const timeLeft = targetTime + delta;

    const timer = new InstantComponentTimer(worker, {
        time: timeLeft,
        limit: delta,
        duration: Math.max(0, Math.round(buildingAnimationTime - flyingDuration)),
        minimalValue: targetTime
    });
    timer.setAlignment(cleverapps.styles.WorkerView.timer);
    unitView.animateAppearAdditionalView("timer", timer);
};

InstantWorkerView.createAboveAnimation = function (unitView, worker) {
    const unitStyles = UnitView.getUnitAnchor(unitView.unit);
    const workerStyles = UnitView.getUnitAnchor(worker.unit);

    const aboveAnimation = UnitView.getUnitImage(worker.unit);
    aboveAnimation.setCompleteListener();
    aboveAnimation.setAnchorPoint(workerStyles.x, workerStyles.y);
    aboveAnimation.setAlignment(unitView.width / 2, unitStyles.y * unitView.height);
    aboveAnimation.setAnimation(0, "building", false);

    unitView.addChild(aboveAnimation);
    return aboveAnimation;
};

InstantWorkerView.removeInstantAnimation = function (unitView) {
    if (unitView.aboveInstantAnimation) {
        unitView.aboveInstantAnimation.removeFromParent();
        delete unitView.aboveInstantAnimation;
    }

    if (unitView.belowInstantAnimation) {
        unitView.belowInstantAnimation.removeFromParent();
        delete unitView.belowInstantAnimation;
    }

    unitView.removeAdditionalView("timer");
};

InstantWorkerView.startMagic = function (unitView, worker, callback) {
    const flyingAnimation = InstantWorkerView.createAboveAnimation(unitView, worker);
    flyingAnimation.setAnimation(0, "jump", cleverapps.styles.InstantWorkerView.jump.repeat);

    InstantWorkerView.jumpAnimation(flyingAnimation, worker.unit, unitView.unit, unitView, () => {
        cleverapps.effects.fire("merge.instantworker.build");
        callback();
    });
};

InstantWorkerView.finishMagic = function (unitView, worker, callback) {
    const movingNode = cleverapps.Scenes.GetMovingNode(unitView);

    const flyingAnimation = InstantWorkerView.createAboveAnimation(unitView, worker);
    flyingAnimation.replaceParentSamePlace(movingNode);
    flyingAnimation.setAnimation(0, "jump_back", cleverapps.styles.InstantWorkerView.jump.repeat);

    InstantWorkerView.jumpAnimation(flyingAnimation, unitView.unit, worker.unit, movingNode, () => {
        callback();
    });
};

InstantWorkerView.jumpAnimation = function (animation, from, to, parent, callback) {
    const mapView = Map2d.currentMap.getMapView();

    const fromPos = parent.convertToNodeSpace(mapView.convertToWorldSpace(from.onGetView() || mapView.alignInGrid(from.x, from.y)));
    const toPos = parent.convertToNodeSpace(mapView.convertToWorldSpace(mapView.alignInGrid(to.x, to.y)));

    const distance = cc.pDistance(fromPos, toPos);

    animation.setAlignment(fromPos);

    animation.runAction(new cc.Sequence(
        new cc.JumpTo(cleverapps.styles.InstantWorkerView.jump.duration, toPos, distance * 0.3, 1),
        new cc.CallFunc(callback),
        new cc.RemoveSelf()
    ));
};

cleverapps.styles.InstantWorkerView = {
    jump: {
        duration: 0.45,
        repeat: true
    },

    progress: {
        type: ScaledProgressBar.Types.red_small,
        width: 80,
        x: 5,
        y: -55,
        offsetY: 15
    },

    timer: {
        x: { align: "center", dx: 0 },
        y: { align: "center", dy: -29 }
    }
};